import {
   USUARIOS_UPDATE_USER_PHONE_NUMBER_DISMISS_ERROR,
   USUARIOS_UPDATE_USER_PHONE_NUMBER_FAILURE,
   USUARIOS_UPDATE_USER_PHONE_NUMBER_SUCCESS,
   USUARIOS_UPDATE_USER_PHONE_NUMBER_BEGIN
  } from './constants';
  import axios from "axios";
  import { REACT_APP_API_ABM_FW } from '../../../common/config';

  export function updateUserPhoneNumber(body) {
    return (dispatch) => { // optionally you can have getState as the second argument
      dispatch({
        type: USUARIOS_UPDATE_USER_PHONE_NUMBER_BEGIN,
      });
      const promise = new Promise((resolve, reject) => {
        const doRequest = axios.put(REACT_APP_API_ABM_FW + "/users/updatePhoneNumber", body);
        doRequest.then(
          (res) => {
            if (res.data.success) {
              dispatch({
                type: USUARIOS_UPDATE_USER_PHONE_NUMBER_SUCCESS,
                data: { res, phoneNumber: body.phoneNumber} ,
              });
              resolve(res);
            } else {
              dispatch({
                type: USUARIOS_UPDATE_USER_PHONE_NUMBER_FAILURE,
                data: { error: res.data.errorMessage },
              });
              reject(res.data.errorMessage);
            }
          },
          (err) => {
            dispatch({
              type: USUARIOS_UPDATE_USER_PHONE_NUMBER_FAILURE,
              data: { error: err },
            });
            reject(err);
          },
        );
      });
      return promise;
    };
  }
  
  // Async action saves request error by default, this method is used to dismiss the error info.
  // If you don't want errors to be saved in Redux store, just ignore this method.
  export function dismissUpdateUserPhoneNumberError() {
    return {
      type: USUARIOS_UPDATE_USER_PHONE_NUMBER_DISMISS_ERROR,
    };
  }
  
  export function reducer(state, action) {
    switch (action.type) {
      case USUARIOS_UPDATE_USER_PHONE_NUMBER_BEGIN:
        return {
          ...state,
          updateUserPhoneNumberPending: true,
          updateUserPhoneNumberError: null,
        };
  
      case USUARIOS_UPDATE_USER_PHONE_NUMBER_SUCCESS:
        let newState = {
          ...state,
          updateUserPhoneNumberPending: false,
          updateUserPhoneNumberError: null,
        }
        newState.editUser.phoneNumber = action.data.phoneNumber
        return newState ;
  
      case USUARIOS_UPDATE_USER_PHONE_NUMBER_FAILURE:
        return {
          ...state,
          updateUserPhoneNumberPending: false,
          updateUserPhoneNumberError: action.data.error,
        };
  
      case USUARIOS_UPDATE_USER_PHONE_NUMBER_DISMISS_ERROR:
        return {
          ...state,
          updateUserPhoneNumberError: null,
        };

      default:
        return state;
    }
  }
  